// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.payment-monitor[data-v-b17610d8] { padding: 20px 0;\n}\n.monitor-section[data-v-b17610d8] { margin-top: 16px;\n}\n.monitor-title[data-v-b17610d8] { font-weight: 600; margin-bottom: 10px;\n}\n.monitor-note[data-v-b17610d8] { color: #909399; font-size: 12px;\n}\r\n", ""]);
// Exports
module.exports = exports;
